import { Component, OnInit, Input } from '@angular/core';
import { AppIcon } from 'src/app/core/models/icons.model';
import { DevHelpers } from 'src/app/core/models/dev-helpers.model';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MdcIconButtonDirective, MdcRippleDirective } from '../top-bar-app/mdc.icon-button.directive';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { Cf2MaterialModule } from '@modules/cf2-material/cf2-material.module';
import { MatIconButton } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';

const randomId = DevHelpers.randomString(6);

@Component({
    selector: 'app-icon-button',
    template: `
        <button
                mdcRipple="false"
                mdcIconButton
                class="material-icons"
                id="{{ id }}"
                [iconOn]="on"
                [iconOff]="off"
                [disabled]="disabled"
                [(on)]="isActive"
                dense="dense">
                <mat-icon>menu</mat-icon>
        </button>
    `,
    styleUrls: ['./icon-button.component.css'],
    imports: [
      CommonModule,
      ReactiveFormsModule,
      MatFormFieldModule,
      FormsModule,
      Cf2MaterialModule,
      MdcRippleDirective,
      MatIcon,
      MatIconModule,
      MatInputModule,
      MdcIconButtonDirective,
    ]
})
export class IconButtonComponent implements OnInit {
  @Input() isActive = false;
  @Input() disabled = false;
  @Input() id: string;
  @Input() on: AppIcon = 'expand_more';
  @Input() off: AppIcon = 'expand_less';
  @Input() dense: boolean;

  constructor() {
    this.id = this.id ? this.id : randomId();
  }

  ngOnInit(): void {}
}
